import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Input, Stack, Link } from "@chakra-ui/react";
import { useAuth } from "@/context/AuthContext";
import { colors } from "@/theme/colors";
import { AuthShell, Field, inputStyle, ErrorNote, SuccessNote } from "@/pages/auth/AuthShell";

export default function ForgotPassword() {
  const { sendPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await sendPasswordReset(email.trim());
      setDone(true);
    } catch (err) {
      setError(err.message || "Unable to send reset email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and we'll send you a reset link."
      footer={
        <Link as={RouterLink} to="/login" color={colors.tealHover} fontWeight="600" data-testid="go-login">
          Back to sign in
        </Link>
      }
    >
      {done ? (
        <SuccessNote>
          If an account exists for <b>{email}</b>, a password reset link is on its way. Check your inbox.
        </SuccessNote>
      ) : (
        <form onSubmit={submit}>
          <Stack gap="4">
            <ErrorNote>{error}</ErrorNote>
            <Field label="Email">
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" {...inputStyle} />
            </Field>
            <Button type="submit" w="full" loading={loading} data-testid="forgot-submit">
              Send reset link
            </Button>
          </Stack>
        </form>
      )}
    </AuthShell>
  );
}
